// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"520b4c22","186":"da163d38","344":"20c8e48a","372":"7bf656b4","377":"35451cd4","738":"e7ea2853","841":"4f236928","856":"e0221203"}[chunkId] + ".chunk.js";
};